import {
  MDBCollapse,
  MDBNavbar,
  MDBNavbarBrand,
  MDBNavbarItem,
  MDBNavbarNav,
  MDBNavbarToggler
} from "mdb-react-ui-kit";
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Login from "../auth/Login";
import MenuIcon from "@mui/icons-material/Menu";
import { useSelector } from "react-redux";
import ThemeToggle from "./ThemeToggle";
import { useThemeMode } from "../../theme/AppThemeProvider";

const Header = () => {
  const logo = process.env.PUBLIC_URL + "/logo512.png";
  const environment = process.env.REACT_APP_ENV;
  const [showBasic, setShowBasic] = useState(false);
  const location = useLocation();
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  const { mode } = useThemeMode();
  const isDark = mode === "dark";

  return (
    <>
      {isLoggedIn && (
        <MDBNavbar expand="lg" className="h-1 p-1" light={!isDark} dark={isDark} bgColor={isDark ? "dark" : "light"}>
          <MDBNavbarBrand as={Link} to="/" className="ms-5">
            <img src={logo} height="30" alt="" loading="lazy" className="me-2"/>
            {environment === "prod" ? "Life Data Hub" : "Life Data Hub - Env: " + environment}
          </MDBNavbarBrand>
          <MDBNavbarToggler
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
            onClick={() => setShowBasic(!showBasic)}
          >
            <MenuIcon/>
          </MDBNavbarToggler>
          <MDBCollapse navbar open={showBasic}>
            <MDBNavbarNav className="d-flex justify-content-end align-items-center">
              <MDBNavbarItem>
                <Link
                  className={`nav-link ${(location.pathname === "/" || location.pathname === "/admin/dashboard") ? "active" : ""}`}
                  to="/"
                >
                  Dashboard
                </Link>
              </MDBNavbarItem>
              <MDBNavbarItem>
                <Link
                  className={`nav-link ${location.pathname === "/admin/panel" ? "active" : ""}`}
                  to="/admin/panel"
                >
                  Адмін панель
                </Link>
              </MDBNavbarItem>
              <MDBNavbarItem>
                <Link
                  className={`nav-link ${location.pathname === "/admin/subscriptions" ? "active" : ""}`}
                  to="/admin/subscriptions"
                >
                  Підписки
                </Link>
              </MDBNavbarItem>
              <MDBNavbarItem>
                <Link
                  className={`nav-link ${location.pathname === "/admin/categories" ? "active" : ""}`}
                  to="/admin/categories"
                >
                  Категорії
                </Link>
              </MDBNavbarItem>
              <MDBNavbarItem>
                <Link
                  className={`nav-link ${location.pathname === "/admin/document-types" ? "active" : ""}`}
                  to="/admin/document-types"
                >
                  Типи документів
                </Link>
              </MDBNavbarItem>
              <MDBNavbarItem>
                <Link
                  className={`nav-link ${location.pathname === "/admin/field-definitions" ? "active" : ""} me-5`}
                  to="/admin/field-definitions"
                >
                  Поля карток
                </Link>
              </MDBNavbarItem>
              <ThemeToggle className="me-3"/>
              <Login setShowBasic={setShowBasic}></Login>
            </MDBNavbarNav>
          </MDBCollapse>
        </MDBNavbar>
      )}
    </>
  );
};

export default Header;
